import React from 'react'
import Modalizer from 'components/modalizer/modalizer'
import LessonCodes from 'components/lesson_codes/lesson_codes'

const LessonCodesModal = props => (<Modalizer modalName={props.modalName} width='552px' closeAction={props.closeModal}>
	<LessonCodes
		codes={props.codes}
		closeModal={props.closeModal}
		dateFormat={props.dateFormat}
		timeFormat={props.timeFormat}
		cancel={props.cancel}
		actualTimestamp={props.actualTimestamp} />
</Modalizer>)

export default LessonCodesModal
